import { SortParams } from 'components';

/* eslint-disable @typescript-eslint/ban-types */
type SortFunction<TItem> = Parameters<Array<TItem>['sort']>[0];

/**
 * util that returns a sort function for alpha-numeric sorting
 *
 * instead of [1,11,2,3] you get [1,2,3,11]
 */
export function localeSort(): SortFunction<string | number>;
export function localeSort<TItem>(
  getSortValue: (item: TItem) => string | number
): SortFunction<TItem>;
export function localeSort<TItem extends {}>(
  getSortValue?: (item: TItem) => string | number
): SortFunction<TItem> {
  return (a: TItem, b: TItem) => {
    const aValue = (getSortValue ? getSortValue(a) : a).toString();
    const bValue = (getSortValue ? getSortValue(b) : b).toString();
    const language = navigator.languages[0] || navigator.language;
    return aValue.localeCompare(bValue, language, {
      numeric: true,
    });
  };
}

export const findColumnNameBySortField = (
  sortField: string,
  sortFields: Record<string, string>
) => {
  return (
    Object.keys(sortFields).find((columnName) => sortFields[columnName] === sortField) ?? sortField
  );
};

/** @deprecated prefer useTableSort*/
export const getColumnSortParams = (sort: SortParams, sortFields: Record<string, string>) => {
  return {
    order: sort.order,
    field: findColumnNameBySortField(sort.field, sortFields),
  };
};

/**Convert SortParams to query variables, supporting mismatch between column name and model attribute
 *
 * Key in sortFields is the Column's name prop
 *
 * Value in sortFields is attribute address on the model.
 *
 * for example:
 *
 * Column has `name='gateStatus'` but the model attribute is `status`
 *
 * `const sortFields = { gateStatus: 'status' }`
 */
export const sortParamsToQueryVariables = (
  { field: columnName, order }: SortParams,
  sortFields: Record<string, string>
) => {
  return {
    sortOrder: order,
    sortField: sortFields[columnName] ?? columnName,
  };
};
